import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import '../css/Navbar.css';

function Navbar({ isAuthenticated, setIsAuthenticated }) {
  const navigate = useNavigate();
  const userType = localStorage.getItem('userType'); // 'admin' ou autre

  const handleLogout = () => {
    localStorage.clear();
    setIsAuthenticated(false);
    navigate('/login');
  };

  const handleLogoClick = () => {
    isAuthenticated ? navigate('/ajouter-cv') : navigate('/');
  };

  return (
    <AppBar position="static" className="navbar-root">
      <Toolbar className="navbar-toolbar">
        <div className="navbar-left" onClick={handleLogoClick}>
          <Typography variant="h6" className="navbar-logo">ParseIT</Typography>
        </div>

        {isAuthenticated && (
          <Box className="navbar-center-buttons">
            
            {userType === 'admin' && (
              <Button className="nav-button" onClick={() => navigate('/dashboard')}>Dashboard</Button>
            )}
            <Button className="nav-button" onClick={() => navigate('/ajouter-cv')}>Nouveau dossier</Button>
            <Button className="nav-button" onClick={() => navigate('/mes-cvs')}>Mes dossiers</Button>
          </Box>
        )}

        <div className="navbar-right">
          {isAuthenticated ? (
            <>
              <Button className="nav-button" onClick={() => navigate('/profile')}>Mon compte</Button>
              <Button className="nav-button" onClick={handleLogout}>Déconnexion</Button>
            </>
          ) : (
            <>
              <Button className="nav-button" onClick={() => navigate('/login')}>Connexion</Button>
              <Button className="nav-button-blue" onClick={() => navigate('/register')}>Créer votre compte</Button>
            </>
          )}
        </div>
      </Toolbar>
    </AppBar>
  );
}

export default Navbar;
